/**
 * [REALTIME] NEW FILE (2026-06-23) — subscribe a component to live DB changes.
 *
 *   useRealtime(['inventory'], () => silentlyRefetch());
 *
 * `refetch` runs whenever any listed dataset's server-side version changes
 * (≈ a few seconds after the DB changes, from ANY source). Keep `refetch`
 * "silent" (no full-page spinner) so live updates don't flicker the UI. The
 * latest `refetch` is always used without re-subscribing on every render.
 */
import { useEffect, useRef } from 'react';
import { subscribeToData } from '../services/realtime';

export function useRealtime(datasets: string[], refetch: () => void): void {
  const ref = useRef(refetch);
  ref.current = refetch;

  // Re-subscribe only when the set of datasets actually changes.
  const key = datasets.join(',');
  useEffect(() => {
    const list = key ? key.split(',') : [];
    if (!list.length) return;
    return subscribeToData(list, () => ref.current());
  }, [key]);
}
